// extracted by mini-css-extract-plugin
module.exports = {"noLabel":"TaxTrax_noLabel__dmIDD","specialCharacter":"TaxTrax_specialCharacter__17NA7","table":"TaxTrax_table__233t9"};